export default "__VITE_ASSET__794d4c68__"